import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import scheme2 from "../assets/scheme2.jpg";
import scheme1 from "../assets/scheme1.jpg";
import founder from "../assets/founder.jpeg";
import modi from "../assets/modi.jpg"
import amit from "../assets/amitshah.jpg"
import mohol from "../assets/mohol.webp"
import krishnan from "../assets/krishnan.webp"
import affortable from "../assets/afforable.webp"
import inclusive from "../assets/inclusive.jpg"
import support from "../assets/support.jpg"
import solar from "../assets/solar.webp"
import aboutImage from "../assets/Gallery7.jpeg"
import "../App.css";
import gallery1 from "../assets/Gallery1.jpeg"
import gallery2 from "../assets/Gallery2.jpeg"
import gallery3 from "../assets/Gallery3.jpeg"
import gallery4 from "../assets/Gallery4.jpeg"
import gallery5 from "../assets/Gallery5.jpeg"

const HomePage = () =>   {
const galleryImages = [gallery1, gallery2, gallery3, gallery4, gallery5];

const [currentIndex, setCurrentIndex] = useState(0);
  const { hash } = useLocation();


  // Auto slide
useEffect(() => {
  const interval = setInterval(() => {
    setCurrentIndex((prev) =>
      prev === galleryImages.length - 1 ? 0 : prev + 1
    );
  }, 2500); // 2.5 sec per slide

  return () => clearInterval(interval);
}, []);

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);

      if (el) {
        // Smooth scroll
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 200); // delay so page fully renders
      }
    }
  }, [hash]);
  return (
    <>
  
      {/* hero section */}
      <section
        id="home"
        className="relative flex flex-col items-center justify-center text-center min-h-screen bg-gradient-to-br from-white via-[#fff7ef] to-[#fde5c4] text-primary overflow-hidden"
      >
        {/* Decorative blobs */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-20 -left-20 w-[25rem] h-[25rem] bg-accent/20 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-0 right-60 w-[28rem] h-[28rem] bg-primary/10 rounded-full blur-3xl animate-ping"></div>
        </div>

        {/* Content Container */}
        <div className="relative z-10 mt-24 md:mt-52 flex flex-col md:flex-row items-center justify-between w-full max-w-7xl mx-auto px-6 md:px-12 py-15 gap-16">
          {/* Left: Hero Text */}
          <div className="text-left md:w-[52%]">
            <h1 className="font-extrabold leading-tight drop-shadow-sm">
              <span className="block text-4xl sm:text-5xl md:text-7xl text-accent">
                Jeeva Shakthi Housing
              </span>
              <span className="block text-xl md:text-3xl text-primary mt-2 font-bold">
                Multistate Cooperative Society Ltd
              </span>
            </h1>

            <p className="mt-6 text-lg md:text-xl text-gray-700 leading-relaxed">
              A visionary cooperative initiative empowering communities,
              ensuring secure housing and nurturing collective growth across
              India.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row gap-5">
              <a
                href="#governmentschemes"
                className="px-10 py-4 bg-gradient-to-r from-accent to-amber-400 rounded-full text-white font-semibold text-lg shadow-lg hover:scale-105 transition-transform duration-300"
              >
                Explore Schemes
              </a>
              <a
                href="#ourleadership"
                className="px-10 py-4 border-2 border-accent text-accent rounded-full font-semibold text-lg hover:bg-accent/10 transition-all duration-300"
              >
                Our Leadership
              </a>
            </div>
          </div>

          {/* Right: Leader Images */}
<div className="md:w-[48%] w-full flex justify-center md:mt-10">
  <div className="relative w-[250px] sm:w-[280px] md:w-[320px] h-[380px] sm:h-[420px] md:h-[460px] overflow-hidden rounded-3xl shadow-xl bg-white/70 backdrop-blur-md">

    {/* IMAGE SLIDES */}
    <div
      className="absolute inset-0 transition-all duration-[1200ms] ease-out"
      style={{
        transform: `translateX(-${currentIndex * 100}%)`,
        display: "flex",
      }}
    >
      {[
        gallery1,
        gallery2,
        gallery3,
        gallery4,
        gallery5,
      ].map((img, index) => (
        <img
          key={index}
          src={img}
          alt="gallery portrait"
          className="min-w-full h-full object-cover"
        />
      ))}
    </div>
  </div>
</div>


        </div>

        {/* Scroll indicator*/}
        <div className=" mt-10 flex flex-col items-center">
          <div className="w-5 h-9 rounded-full border-2 border-accent flex justify-center">
            <div className="w-1 h-3 bg-accent rounded-full animate-bounce mt-1"></div>
          </div>
          <span className="mt-3 text-sm text-primary/80 font-medium tracking-wide animate-pulse">
            See More
          </span>
        </div> 
        <div className="absolute bottom-0 left-0 w-full h-[80px] bg-gradient-to-t from-amber-400/10 to-transparent"></div>
      </section>

      {/* About Us */}
      {/* Mission and Vision */}
      <section id="aboutus" className="relative py-28 bg-white overflow-hidden">
        
<div className="w-full bg-white py-16 md:py-20">
  <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-2 gap-6 items-center">

    {/* Portrait Image */}
    <div className="flex justify-center md:justify-center">
      <div className="w-full max-w-[320px]">
        <img
          src={aboutImage}
          alt="About Jeeva Shakthi Housing"
          className="w-full rounded-2xl border border-accent shadow-md object-cover"
        />
      </div>
    </div>

    {/* Text */}
    <div className="text-left">
      <h2 className="text-4xl md:text-5xl font-extrabold text-primary leading-tight">
        About <span className="text-accent">Jeeva Shakthi Housing</span>
      </h2>

      <p className="text-base md:text-lg text-gray-700 mt-5 leading-relaxed text-justify">
        Jeeva Shakthi Housing Multistate Cooperative Society Limited 
        is a registered 
        <span className="font-semibold text-primary"> multistate cooperative society </span>
        under the MSCS Act, 2002. We are officially recognized by the
        <span className="font-semibold text-accent"> Central Registrar of Cooperative Societies (CRCS) </span>,
        Ministry of Cooperation, Government of India, New Delhi, with
        Registration Number:
        <span className="font-semibold text-primary"> MSCS/CR/1407/2023</span>.
        Our area of operation extends across 
        <span className="font-semibold text-accent"> Tamil Nadu </span>
        and 
        <span className="font-semibold text-accent"> Puducherry</span>.
      </p>
    </div>

  </div>
</div>


        <div className="absolute -top-20 left-10 w-[22rem] h-[22rem] bg-accent/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-0 right-0 w-[28rem] h-[28rem] bg-primary/10 rounded-full blur-3xl animate-ping"></div>

        <div className="relative z-10 max-w-6xl mx-auto text-center px-6 md:px-12">
          <h2 className="text-4xl md:text-5xl font-extrabold text-primary">
            Our Vision & <span className="text-accent"> Mission</span>
          </h2>
          <div className="w-24 h-1 bg-accent mx-auto mt-4 rounded-full"></div>

          <p className="mt-8 text-lg md:text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
            We were founded with a noble{" "}
            <span className="font-semibold text-primary">mission</span> — to
            make{" "}
            <span className="font-semibold text-accent">quality housing</span> a
            reality for every individual, regardless of background or income
            level. Our{" "}
            <span className="font-semibold text-primary">commitment</span> lies
            in creating{" "}
            <span className="font-semibold text-accent">affordable</span>,{" "}
            <span className="font-semibold text-accent">sustainable</span> and{" "}
            <span className="font-semibold text-accent">well-built homes</span>{" "}
            that uplift the lives of our members and their families. Through our{" "}
            <span className="font-semibold text-primary">
              cooperative model
            </span>
            , we ensure that every{" "}
            <span className="font-semibold text-accent">rupee invested</span>{" "}
            brings maximum value, making{" "}
            <span className="font-semibold text-accent">home ownership</span>{" "}
            attainable for all. Our projects are structured under the{" "}
            <span className="font-semibold text-primary">
              Pradhan Mantri Awas Yojana (PMAY)
            </span>{" "}
            and other central and state-level housing initiatives, aligning with
            the vision of
            <span className="text-xl font-bold text-accent">
              “Housing for All”
            </span>
            .
          </p>
        </div>

        <div className="relative z-10 mt-16 flex flex-col md:flex-row items-center justify-center gap-10 px-6 md:px-0">
          {[
            {
              title: "Our Vision",
              text: "Empowering every family with access to secure, quality housing — nurturing communities that thrive with unity, dignity and opportunity.",
              position: "md:-rotate-2",
            },
            {
              title: "Our Mission",
              text: "To build affordable homes through cooperative strength, transparency and innovation — aligning with national housing initiatives like PMAY.",
              position: "md:translate-y-8",
            },
            {
              title: "Our Purpose",
              text: "We aim to transform housing dreams into reality, ensuring that each investment adds value to people’s lives and strengthens the nation’s growth.",
              position: "md:rotate-2",
            },
          ].map((card, index) => (
            <div
              key={index}
              className={`relative bg-white/90 backdrop-blur-md rounded-3xl shadow-xl border border-white/40 p-8 max-w-sm text-center hover:scale-105 transition-all duration-500 ${card.position}`}
            >
              <h3 className="text-2xl font-bold text-accent mb-4">
                {card.title}
              </h3>
              <p className="text-gray-700 text-base leading-relaxed">
                {card.text}
              </p>

              <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-24 h-1 bg-accent/30 rounded-full"></div>
            </div>
          ))}
        </div>
      </section>

      {/* Government Schemes */}
      <section
        id="governmentschemes"
        className="relative py-28 bg-gradient-to-br from-white via-[#fffaf4] to-[#fff1dc] overflow-hidden"
      >
        <div className="text-center mb-20 px-6">
          <h2 className="text-4xl md:text-5xl font-extrabold text-primary">
            Overview of <span className="text-accent">Government Schemes</span>
          </h2>
          <p className="mt-4 text-lg text-gray-700 max-w-3xl mx-auto">
            Supporting India’s mission for affordable housing and sustainable
            energy.
          </p>
        </div>

        <div className="max-w-7xl mx-auto px-6 md:px-12 space-y-24 relative z-10">
          <div className="relative flex flex-col md:flex-row items-center gap-12 p-6 md:p-10 bg-gradient-to-r from-[#fff8f2] to-white rounded-3xl shadow-xl border-l-4 border-accent/60">
            <img
              src={scheme1}
              alt="PMAY"
              className="w-full md:w-1/3 rounded-2xl shadow-lg"
            />

            <div className="md:w-2/3 text-left">
              <h3 className="text-3xl font-bold text-accent">
                Pradhan Mantri Awas Yojana (PMAY)
              </h3>
              <p className="mt-5 text-lg text-gray-700 leading-relaxed">
                Launched in{" "}
                <span className="font-semibold text-accent">2015</span>,
                <span className="font-bold text-primary">
                  {" "}
                  Pradhan Mantri Awas Yojana (PMAY)&nbsp;
                </span>
                ensures{" "}
                <span className="text-accent font-semibold">
                  “Housing for All”
                </span>{" "}
                by providing
                <span className="text-primary font-medium">
                  {" "}
                  pucca homes
                </span>{" "}
                to
                <span className="font-semibold text-accent">
                  {" "}
                  EWS, LIG
                </span>{" "}
                and
                <span className="font-semibold text-accent"> MIG</span>{" "}
                citizens. It offers
                <span className="font-semibold text-primary">
                  {" "}
                  interest subsidies
                </span>{" "}
                under the
                <span className="text-accent font-semibold">
                  {" "}
                  Credit-Linked Subsidy Scheme (CLSS)
                </span>
                , empowering families to own safe, affordable homes across
                India.
              </p>

              <p className="mt-4 text-lg text-gray-700 leading-relaxed">
                The scheme encourages both{" "}
                <span className="text-primary font-semibold">public&nbsp;</span>
                and{" "}
                <span className="text-primary font-semibold">
                  private partnerships
                </span>{" "}
                to promote
                <span className="text-accent font-semibold">
                  {" "}
                  sustainable housing development
                </span>{" "}
                nationwide.
              </p>
            </div>
          </div>

          <div className="relative flex flex-col md:flex-row-reverse items-center gap-12 p-6 md:p-10 bg-gradient-to-l from-[#fef6e8] to-white rounded-3xl shadow-xl border-r-4 border-accent/60">
            <img
              src={scheme2}
              alt="PM Surya Ghar"
              className="w-full md:w-1/3 rounded-2xl shadow-lg"
            />

            <div className="md:w-2/3 text-left">
              <h3 className="text-3xl font-bold text-accent">
                PM Surya Ghar: Muft Bijli Yojana
              </h3>
              <p className="mt-5 text-lg text-gray-700 leading-relaxed">
                A renewable energy initiative encouraging{" "}
                <span className="text-accent font-semibold">
                  rooftop solar adoption
                </span>
                . By installing{" "}
                <span className="text-accent font-semibold">solar panels</span>,
                households can produce{" "}
                <span className="text-accent font-semibold">
                  free electricity
                </span>{" "}
                and even{" "}
                <span className="text-accent font-semibold">
                  sell surplus energy
                </span>{" "}
                back to the grid.
              </p>

              <p className="mt-4 text-lg text-gray-700 leading-relaxed">
                It helps{" "}
                <span className="text-accent font-semibold">
                  lower energy costs
                </span>
                , supports{" "}
                <span className="text-accent font-semibold">
                  sustainability&nbsp;
                </span>
                 and aligns with India’s{" "}
                <span className="text-accent font-semibold">
                  clean energy goals
                </span>{" "}
                through government subsidies.
              </p>
            </div>
          </div>
        </div>

        <div className="absolute bottom-0 left-0 w-full h-[60px] bg-gradient-to-t from-accent/5 to-transparent"></div>
      </section>

      <section
        id="affordablehousingadvantage"
        className="relative py-28 bg-white overflow-hidden"
      >
        <div className="max-w-6xl mx-auto px-6 md:px-12 relative">
          {/* Title */}
          <h2 className="text-center text-4xl md:text-5xl font-extrabold text-primary mb-20 relative z-10">
            <span className="text-accent">Affordable Housing</span> Advantage
          </h2>

          {/* Center Line (starts below title, not from top) */}
          <div className="hidden md:block absolute top-[180px] bottom-0 left-1/2 w-[2px] bg-gradient-to-b from-accent/40 via-primary/30 to-accent/40 transform -translate-x-1/2"></div>

          {/* Content Blocks */}
          <div className="space-y-24 md:space-y-32">
            {/* 1 */}
            <div className="relative flex flex-col md:flex-row items-center md:items-start">
              <span className="hidden md:block absolute left-1/2 w-6 h-6 bg-accent rounded-full transform -translate-x-1/2 top-6"></span>

              <div className="md:w-1/2 md:pr-16 text-center md:text-left">
                <h3 className="text-2xl font-bold text-primary">
                  Affordable Housing
                </h3>
                <p className="mt-4 text-gray-700 leading-relaxed">
                  We take pride in constructing residential units at{" "}
                  <span className="text-accent font-semibold">20% lower</span>{" "}
                  than the prevailing market price. This ensures that our{" "}
                  <span className="text-primary font-semibold">
                    members — both ordinary and nominal
                  </span>{" "}
                  — as well as the general public can access quality homes at
                  truly{" "}
                  <span className="text-accent font-semibold">
                    affordable rates
                  </span>
                  . Beyond affordable pricing, we deliver{" "}
                  <span className="text-primary font-semibold">
                    high standards in planning, materials and craftsmanship
                  </span>
                  , ensuring that every project meets{" "}
                  <span className="text-primary font-semibold">
                    long-term durability and comfort
                  </span>{" "}
                  expectations.
                </p>
              </div>

              <div className="md:w-1/2 md:pl-16 mt-8 md:mt-0 flex justify-center">
                <img
                  src={affortable}
                  className="w-full max-w-sm rounded-2xl shadow-xl"
                  alt="Affordable Housing"
                />
              </div>
            </div>

            {/* 2 */}
            <div className="relative flex flex-col md:flex-row-reverse items-center md:items-start">
              <span className="hidden md:block absolute left-1/2 w-6 h-6 bg-accent rounded-full transform -translate-x-1/2 top-6"></span>

              <div className="md:w-1/2 md:pl-16 text-center md:text-left">
                <h3 className="text-2xl font-bold text-primary">
                  Inclusive Benefits for SC/ST Members
                </h3>
                <p className="mt-4 text-gray-700 leading-relaxed">
                  <span className="text-primary font-semibold">
                    Jeeva Shakthi Housing
                  </span>{" "}
                  gives special priority to{" "}
                  <span className="text-accent font-semibold">inclusivity</span>
                  .{" "}
                  <span className="text-primary font-semibold">
                    SC and ST members
                  </span>{" "}
                  are entitled to an{" "}
                  <span className="text-accent font-semibold">
                    additional 10% reduction
                  </span>{" "}
                  on construction costs, over and above the eligible{" "}
                  <span className="text-primary font-semibold">
                    government subsidies and PMAY benefits
                  </span>
                  . This initiative supports{" "}
                  <span className="text-primary font-semibold">
                    equitable growth
                  </span>{" "}
                  and promotes{" "}
                  <span className="text-accent font-semibold">
                    social upliftment through home ownership
                  </span>
                  .
                </p>
              </div>

              <div className="md:w-1/2 md:pr-16 mt-8 md:mt-0 flex justify-center">
                <img
                  src={inclusive}
                  className="w-full max-w-sm rounded-2xl shadow-xl"
                  alt="Inclusive Benefits"
                />
              </div>
            </div>

            {/* 3 */}
            <div className="relative flex flex-col md:flex-row items-center md:items-start">
              <span className="hidden md:block absolute left-1/2 w-6 h-6 bg-accent rounded-full transform -translate-x-1/2 top-6"></span>

              <div className="md:w-1/2 md:pr-16 text-center md:text-left">
                <h3 className="text-2xl font-bold text-primary">
                  Member Welfare & Monthly Support
                </h3>
                <p className="mt-4 text-gray-700 leading-relaxed">
                  Our responsibility does not end with constructing houses. We
                  are deeply committed to the{" "}
                  <span className="text-accent font-semibold">
                    welfare of our members
                  </span>{" "}
                  even after they move into their new homes. Members who have
                  completed their housing projects through our cooperative
                  receive{" "}
                  <span className="text-primary font-semibold">
                    monthly grocery and essential items
                  </span>{" "}
                  at <span className="text-accent font-semibold">subsidy</span>.
                  This helps reduce{" "}
                  <span className="text-primary font-semibold">
                    regular living expenses
                  </span>
                  , easing the{" "}
                  <span className="text-accent font-semibold">
                    financial burden
                  </span>{" "}
                  of home loan repayments and daily costs.
                </p>
              </div>

              <div className="md:w-1/2 md:pl-16 mt-8 md:mt-0 flex justify-center">
                <img
                  src={support}
                  className="w-full max-w-sm rounded-2xl shadow-xl"
                  alt="Member Welfare"
                />
              </div>
            </div>

            {/* 4 */}
            <div className="relative flex flex-col md:flex-row-reverse items-center md:items-start">
              <span className="hidden md:block absolute left-1/2 w-6 h-6 bg-accent rounded-full transform -translate-x-1/2 top-6"></span>

              <div className="md:w-1/2 md:pl-16 text-center md:text-left">
                <h3 className="text-2xl font-bold text-primary">
                  Promoting Green Energy – Solar Subsidy
                </h3>
                <p className="mt-4 text-gray-700 leading-relaxed">
                  We provide{" "}
                  <span className="text-primary font-semibold">
                    exclusive additional subsidies&nbsp;
                  </span> 
                    to encourage solar power installations under{" "}
                  <span className="font-semibold text-accent">
                    PM Surya Ghar: Muft Bijli Yojana
                  </span>
                  . Our society offers{" "}
                  <span className="text-primary font-semibold">
                    incentives to promote clean energy adoption&nbsp;
                  </span>
                  and reduce electricity costs for all our members.
                </p>

                <ul className="mt-3 text-gray-700 leading-relaxed">
                  <li>
                    •{" "}
                    <span className="text-primary font-semibold">
                      1.1 kW Solar System
                    </span>{" "}
                    –{" "}
                    <span className="text-accent font-semibold">
                      ₹7,500 subsidy
                    </span>
                  </li>
                  <li>
                    •{" "}
                    <span className="text-primary font-semibold">
                      2 kW Solar System
                    </span>{" "}
                    –{" "}
                    <span className="text-accent font-semibold">
                      ₹15,000 subsidy
                    </span>
                  </li>
                  <li>
                    •{" "}
                    <span className="text-primary font-semibold">
                      Above 3 kW Solar System
                    </span>{" "}
                    –{" "}
                    <span className="text-accent font-semibold">
                      ₹22,000 subsidy
                    </span>
                  </li>
                </ul>
              </div>

              <div className="md:w-1/2 md:pr-16 mt-8 md:mt-0 flex justify-center">
                <img
                  src={solar}
                  className="w-full max-w-sm rounded-2xl shadow-xl"
                  alt="Solar Subsidy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* leadership  */}
      <section
        id="ourleadership"
        className="relative py-28 bg-gradient-to-br from-white via-[#fffaf4] to-[#fff1dc] overflow-hidden"
      >
        <div className="max-w-6xl mx-auto px-6 md:px-12 flex flex-col md:flex-row items-center gap-12 relative">
          {/* Left - Image */}
          <div className="w-full md:w-1/2 relative">
            <div className="rounded-2xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-500">
              <img
                src={founder}
                alt="Dr. A. S. Selvaraj"
                className="w-full h-[460px] object-cover"
              />
            </div>

            {/* Floating Info Card */}
            <div className="absolute -bottom-6 -left-6 bg-primary text-white px-6 py-4 rounded-xl shadow-lg">
              <p className="font-semibold text-lg">Dr. A. S. Selvaraj</p>
              <p className="text-sm opacity-90">
                Chairman, Jeeva Shakthi Housing
              </p>
            </div>
          </div>

          {/* Right - Text Content */}
          <div className="w-full md:w-1/2">
            <h2 className="text-4xl md:text-5xl font-extrabold text-primary mb-6">
              Our <span className="text-accent">Leadership</span>
            </h2>

            <p className="text-gray-700 leading-relaxed">
              Our esteemed{" "}
              <span className="text-accent font-semibold">
                Chairman, Dr. A. S. Selvaraj
              </span>
              , brings over{" "}
              <span className="text-accent font-semibold">
                25 years of experience
              </span>{" "}
              in the construction and housing sector. Under his visionary
              leadership, the society has established a strong foundation built
              on trust, transparency and member-first governance.
            </p>

            <p className="mt-4 text-gray-700 leading-relaxed">
              Supported by a team of expert{" "}
              <span className="text-accent font-semibold">architects</span>,
              <span className="text-accent font-semibold">
                {" "}
                civil engineers
              </span>
               and professionals across our{" "}
              <span className="text-accent font-semibold">
                executive, state-level
              </span>{" "}
              and
              <span className="text-accent font-semibold">
                {" "}
                district-level committees
              </span>
              , we ensure every project reflects a balance of
              <span className="text-accent font-semibold">
                {" "}
                quality, innovation
              </span>{" "}
              and
              <span className="text-accent font-semibold">
                {" "}
                social responsibility
              </span>
              .
            </p>
          </div>
        </div>

        {/* Decorative gradient fade (same as other sections) */}
        <div className="absolute bottom-0 left-0 w-full h-[80px] bg-gradient-to-t from-[#fde5c4]/20 to-transparent"></div>
      </section>

      {/* gallery */}
      <section
        id="ourgallery"
        className="relative py-28 bg-white overflow-hidden"
      >
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          {/* Title */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-extrabold text-primary">
              Our <span className="text-accent">Gallery</span>
            </h2>
            <p className="mt-4 text-gray-700 max-w-2xl mx-auto">
              Explore some of our proud moments and housing achievements —
              <span className="font-semibold text-primary">
                {" "}
                each picture tells a story of trust and progress.
              </span>
            </p>
          </div>

          {/* Masonry Gallery */}
          <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 space-y-6">
            {[...Array(11)].map((_, i) => (
              <div
                key={i}
                className="relative overflow-hidden rounded-2xl border border-gray-200 shadow-md group transition-transform duration-500 hover:scale-105"
              >
                <img
                  src={`/gallery/Gallery${i + 1}.jpeg`}
                  alt={`Gallery ${i + 1}`}
                  className="w-full object-cover rounded-2xl"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-500"></div>
              </div>
            ))}
          </div>
        </div>
      </section>

{/* Ministry Leadership Section */}
<section id="ministry" className="w-full bg-white py-16">
  <div className="max-w-7xl mx-auto px-6 md:px-10">

    {/* Section Title */}
    <h2 className="text-3xl md:text-4xl font-extrabold text-primary text-center mb-10">
      Hon’ble <span className="text-accent">Ministry</span>
    </h2>

    {/* Leaders Grid */}
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 justify-items-center">

      {[
        {
          name: "Shri Narendra Modi",
          role: "Hon’ble Prime Minister of India",
          img: modi,
        },
        {
          name: "Shri Amit Shah",
          role: "Hon’ble Minister for Home and Cooperation",
          img: amit,
        },
        {
          name: "Shri Murlidhar Mohol",
          role: "Hon’ble Minister of State for Cooperation and Civil Aviation",
          img: mohol,
        },
        {
          name: "Shri Krishan Pal Gurjar",
          role: "Hon’ble Minister of State for Cooperation",
          img: krishnan,
        },
      ].map((leader) => (
        <div
          key={leader.name}
          className="
            bg-white rounded-2xl shadow-lg p-5 
            flex flex-col items-center text-center
            w-[230px] md:w-[250px] h-[260px]
            hover:shadow-xl hover:scale-[1.03] transition-all duration-300
          "
        >
          <img
            src={leader.img}
            alt={leader.name}
            className="
              w-28 h-28 md:w-32 md:h-32 
              rounded-full object-cover border-4 border-accent/70 shadow-md
            "
          />

          <h3 className="mt-4 text-base md:text-lg font-semibold text-primary leading-tight">
            {leader.name}
          </h3>

          <p className="text-sm text-gray-600 leading-tight mt-2 text-center">
            {leader.role}
          </p>
        </div>
      ))}

    </div>
  </div>
</section>


      <section className="relative py-28 bg-gradient-to-br from-white via-[#fffaf4] to-[#fff1dc] overflow-hidden">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl md:text-5xl font-extrabold text-primary mb-6">
            Our<span className="font-extrabold text-accent"> Commitment</span>
          </h2>
          <p className="mt-6 text-lg md:text-xl text-gray-700 leading-relaxed">
            At{" "}
            <span className="font-semibold text-accent">
              Jeeva Shakthi Housing Multistate Cooperative Society
              Ltd.
            </span>
            , we believe that a home is more than four walls — it is a secure
            foundation for a brighter future.
          </p>
          <p className="mt-4 text-lg md:text-xl text-gray-700 leading-relaxed">
            We are dedicated to empowering our members through{" "}
            <span className="font-semibold text-accent">
              affordable housing
            </span>
             ongoing{" "}
            <span className="font-semibold text-accent">welfare programs</span>{" "}
            and{" "}
            <span className="font-semibold text-accent">
              sustainable living initiatives
            </span>{" "}
            that bring lasting prosperity to communities across Tamil Nadu and
            Puducherry.
          </p>
        </div>
      </section>

   
    </>
  );
}

export default HomePage;
